import React from "react";
import cn from "classnames";
import styles from "./DeclineModal.module.sass";
import Icon from "../../Icon";
import { getDeclineTemplate } from "../../../utils/collabDecline";

/**
 * DeclineModal - A lightweight confirmation modal for declining collaboration requests.
 * 
 * Offers two actions:
 * - Send: Immediately sends the decline message
 * - Edit: Inserts the decline text into the composer for editing before sending
 */
const DeclineModal = ({ 
    visible, 
    onClose, 
    onSend, 
    onEdit 
}) => {
    const declineText = getDeclineTemplate('default');
    
    const handleSend = () => {
        onSend(declineText);
        onClose();
    };
    
    const handleEdit = () => {
        onEdit(declineText);
        onClose();
    };
    
    const handleKeyDown = (e) => {
        if (e.key === 'Escape') {
            onClose();
        }
    };
    
    if (!visible) return null;
    
    return (
        <div 
            className={styles.overlay} 
            onClick={onClose}
            onKeyDown={handleKeyDown}
            role="dialog"
            aria-modal="true"
            aria-labelledby="decline-modal-title"
        >
            <div 
                className={styles.modal} 
                onClick={(e) => e.stopPropagation()}
            >
                <div className={styles.header}>
                    <h3 id="decline-modal-title" className={styles.title}>
                        Decline Collaboration
                    </h3>
                    <button 
                        className={styles.closeBtn}
                        onClick={onClose}
                        aria-label="Close"
                    >
                        <Icon name="close" size="16" />
                    </button>
                </div>
                
                <div className={styles.content}>
                    <p className={styles.label}>Message preview:</p>
                    <div className={styles.preview}>
                        {declineText}
                    </div>
                </div>
                
                <div className={styles.actions}>
                    <button 
                        className={cn(styles.btn, styles.editBtn)}
                        onClick={handleEdit}
                    >
                        <Icon name="edit" size="16" />
                        Edit
                    </button>
                    <button 
                        className={cn(styles.btn, styles.sendBtn)}
                        onClick={handleSend}
                        autoFocus
                    >
                        <Icon name="send" size="16" />
                        Send
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeclineModal;
